import { breakpoints, Button, Inline, Stack } from '@etg/wings';
import { Pictogram } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useHistory } from 'react-router-dom';
import { routes } from '../../../../constants/routesAndApisConstants';
import { errorMessageToTextKeyId } from '../../constants/errorMessages';
import type { makeOrderResponseMessages } from '../../constants/makeOrderResponse';
import { shouldRedirectToResultPage, shouldRedirectToStartPage } from './utils';

const pictogramStyles = css`
  height: 175px;
`;

interface ErrorContentProps {
  brand: string;
  messageId: keyof typeof makeOrderResponseMessages;
  onClose: () => void;
}

const ErrorContent = ({ brand, messageId, onClose }: ErrorContentProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const errorMessage = t(`PaymentPage.ErrorModal.${errorMessageToTextKeyId[messageId]}.Message`);

  const handleClose = () => {
    if (shouldRedirectToStartPage(messageId)) {
      sessionStorage.setItem('hasPaymentFailed', 'true');
      history.push(routes.START);
    }
    if (shouldRedirectToResultPage(messageId)) {
      history.push(routes.RESULT);
    }
    onClose();
  };

  return (
    <Stack>
      <Inline align="center">
        <Pictogram brand={brand} className={pictogramStyles} id="generic-error" />
      </Inline>
      <p>{errorMessage}</p>
      <Inline align="end" collapseBelow={breakpoints._560}>
        <Button data-testid="dialog-close" onClick={handleClose} variant="primary">
          {shouldRedirectToResultPage(messageId)
            ? t('PaymentPage.ErrorModal.GoBackToSearch.Button.Text')
            : t('PaymentPage.ErrorModal.TryAgain.Button.Text')}
        </Button>
      </Inline>
    </Stack>
  );
};

export default ErrorContent;
